import {graphql} from 'react-apollo';
import {createNewTripboardMutation} from '../../graphql';
import edap from '../../utils/edap';
import TripBoard from '../TripBoard/TripBoard';
import {readPreviewsCache, writePreviewsCache} from './with-fetch-previews';

export const addTripBoardToCache = (hav, pageSize, listingPageSize) => (proxy, response) => {
    const {data} = response;

    const cache = readPreviewsCache(proxy, hav, pageSize, listingPageSize);
    if (cache && data && data.createTripBoard && cache.paginatedTripBoards) {
        cache.paginatedTripBoards.tripBoards = [{...data.createTripBoard}, ...cache.paginatedTripBoards.tripBoards];

        writePreviewsCache(proxy, hav, pageSize, listingPageSize, cache);
    }
};

export const handleOnMutationComplete = (listingId) => (data) => {
    const createTripBoard = (data && data.createTripBoard) || {};
    const {uuid, stay, listings, name, user} = createTripBoard;
    const {role = {}} = user || {};
    const {adultCount, childrenCount, petsIncluded} = stay || {};
    const {arrival, departure} = (stay && stay.dateRange) || {};
    const firstListing = (listings && listings[0]) || {};
    const firstImage = (firstListing.images && firstListing.images[0] && firstListing.images[0].c6_uri) || '';
    TripBoard.confirm(name, firstImage, listingId, uuid);
    edap.boardSaved(true, adultCount, childrenCount, petsIncluded, arrival, departure, listingId, uuid);
    edap.create(uuid, listingId, role.type);
};

export const handleOnMutationError = (listingId) => () => {
    TripBoard.showCreateError(listingId);
    edap.boardCreateError(listingId);
};

export const optimisticNewTripBoardResponse = (name, listingRefs, stay, thumbnailUrl) => {
    const reducedListings = listingRefs.map((listingId) => ({
        __typename: 'Listing',
        listingId,
        images: [{__typename: 'Image', c6_uri: thumbnailUrl, width: 800, height: 600}]
    }));
    const newStay = {__typename: 'Stay', ...stay};
    if (newStay.dateRange) {
        newStay.dateRange.__typename = 'StayDateRange';
    }
    return {
        createTripBoard: {
            __typename: 'createTripBoard',
            uuid: -1,
            name,
            user: {
                __typename: 'TripBoardUser',
                role: {
                    __typename: 'UserRole',
                    type: 'OWNER'
                }
            },
            stay: newStay,
            listings: reducedListings,
            listingRefs
        }
    };
};

const withCreateNewTripBoard = graphql(createNewTripboardMutation, {
    options: ({mutationConfig, listingId}) => ({
        ...mutationConfig,
        onError: handleOnMutationError(listingId),
        onCompleted: handleOnMutationComplete(listingId)
    }),
    name: 'createTripBoard',
    alias: 'withCreateNewTripBoardMutation'
});

export default withCreateNewTripBoard;
